import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default class LinkButton extends React.Component {

    render() {
        const {
            to,
            text,
            target,
            className,
        } = this.props;

        const btnClasses = className.indexOf('btn-primary') > -1 ? '' : 'btn-default';
        const classes = `btn waves-effect waves-float ${className} ${btnClasses}`;

        return (
            <Link
                to={to}
                type="button"
                target={target}
                className={classes}
                children={text}
            />
        );
    }

}

LinkButton.propTypes = {
    to: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    target: PropTypes.string,
    className: PropTypes.string,
};

LinkButton.defaultProps = {
    text: '',
    target: undefined, // ¡Ojo! Esto puede afectar a los breabcrumbs (antiguo valor: _self)
    className: '',
};



// WEBPACK FOOTER //
// ./src/app/shared/components/LinkButton.jsx